module.exports = __webpack_public_path__ + "static/media/operator-active-hub.bd48a6dd.svg";